import PropTypes from 'prop-types';
import { useValidation } from '@eti/providers';
import { ToggleBar as EtiToggleBar } from '@eti/components';
import { Field } from 'redux-form';
import { getToggleError } from '../../utils/error';
import { jsx as _jsx } from "react/jsx-runtime";
const isFalsy = val => val === null || typeof val === 'undefined' || typeof val === 'string' && !val;
const decideSelectedValue = (override, selectedValue, value) => {
  if (override) {
    return !isFalsy(value) ? value : null;
  }
  return selectedValue;
};
const mapPropsToProps = _ref => {
  let {
    input,
    meta,
    options = [],
    validate,
    selectedValue,
    shouldOverrideSelectedValue = true,
    ...props
  } = _ref;
  return {
    ...props,
    dataTestId: props['data-testid'],
    error: getToggleError(meta),
    isRequired: Boolean(validate),
    onFocus: input.onFocus,
    onValueChange: input.onChange,
    options,
    selectedValue: decideSelectedValue(shouldOverrideSelectedValue, selectedValue, input.value)
  };
};
const ToggleBar = props => /*#__PURE__*/_jsx(EtiToggleBar, {
  ...mapPropsToProps(props)
});
const ToggleBarField = _ref2 => {
  let {
    name,
    formatGet,
    formatSet,
    onChange,
    validationRuleName,
    ...props
  } = _ref2;
  const validate = useValidation(validationRuleName);
  return /*#__PURE__*/_jsx(Field, {
    component: ToggleBar,
    format: formatGet,
    name: name,
    normalize: formatSet,
    onChange: onChange,
    props: {
      ...props,
      validate
    },
    validate: validate
  });
};
ToggleBarField.propTypes = {
  formatGet: PropTypes.func,
  formatSet: PropTypes.func,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
      priceRaw: PropTypes.number,
      value: PropTypes.string
    }))])
  })),
  validationRuleName: PropTypes.string
};
export default ToggleBarField;
//# sourceMappingURL=ToggleBar.js.map